module.exports = __webpack_public_path__ + "static/media/home_white.282d098a.svg";